import DropdownSection from "ds/components/Dropdown/Section";
import SelectEmptyPlaceholder from "ds/components/Select/EmptyPlaceholder";

const SpaceSelectEmptyItem = () => {
  return (
    <DropdownSection>
      <SelectEmptyPlaceholder />
    </DropdownSection>
  );
};

export default SpaceSelectEmptyItem;
